import EmptyState from '../../../components/EmptyState';
import { UserLinks } from '../../../components/UserLinks';
import { useFormatUtils } from '../../../hooks/useFormatUtils';
import type { FeedbackData } from '../../../types/feedback';

interface FeedbackSubmissionsTableProps {
    feedbackSubmissions: FeedbackData[];
}

export default function FeedbackSubmissionsTable({ feedbackSubmissions }: FeedbackSubmissionsTableProps) {
    const { formatDate } = useFormatUtils();

    if (feedbackSubmissions.length === 0) {
        return (
            <EmptyState
                title="No data available"
                description="No feedback submissions found."
            />
        );
    }

    return (
        <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="px-4 sm:px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-medium text-gray-900">Recent Feedback Submissions</h3>
                <p className="mt-1 text-sm text-gray-600">Latest user feedback and comments</p>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Feedback</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {feedbackSubmissions.map(feedback => (
                            <tr key={feedback.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {formatDate(feedback.createdAt)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <div className="flex flex-col gap-1">
                                        <div className="font-medium">{feedback.userEmail || 'Anonymous'}</div>
                                        <div className="text-xs text-gray-500">{feedback.userId}</div>
                                        <UserLinks userId={feedback.userId} />
                                    </div>
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-900 max-w-xs">
                                    <div className="break-words">
                                        {feedback.text}
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
                                        {feedback.source || 'unknown'}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
} 